/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  // NOOVI (noovi-ai-autonomous — Fase 49-B): resumo de conversa por IA nativa.
  getSummary(conversationID) {
    return axios.get(`${this.url}/${conversationID}/summary`);
  }

  generateSummary(conversationID) {
    return axios.post(`${this.url}/${conversationID}/summarize`);
  }
}

export default new ConversationApi();
